import { proxyPoolProtocolOptions } from '@fd/common/biz/proxyPoolProtocolOptions';
import OptionField from '@fd/frontend/components/ProxyPoolCreatePage/OptionFieldCard';
import {
  RadioGroup,
  RadioGroupItem,
} from '@fd/frontend/components/ui/RadioGroup';
import useProxyPoolCreationForm from '@fd/frontend/store/proxyPoolCreationFormStore';

export default function ProtocolCard() {
  return (
    <OptionField.Card>
      <OptionField.Body>
        <OptionField.Title>Protocol</OptionField.Title>
        <OptionField.Description>
          To specify the connection method based on your target applications and
          security needs.
        </OptionField.Description>
      </OptionField.Body>
      <ProtocolSelect />
    </OptionField.Card>
  );
}

function ProtocolSelect() {
  const { protocol, setProtocol } = useProxyPoolCreationForm();

  return (
    <RadioGroup
      value={protocol}
      onValueChange={setProtocol}
      className="flex flex-col sm:flex-row gap-3 sm:gap-10"
    >
      {proxyPoolProtocolOptions.map((option) => (
        <label
          key={option.value}
          className="flex flex-row gap-3 items-center cursor-pointer"
        >
          <RadioGroupItem value={option.value} />
          {option.label}
        </label>
      ))}
    </RadioGroup>
  );
}
